export default __webpack_public_path__ + "static/media/logoBPayHorizontal64Blue.adfcd62c.svg";